function formatNumberWithCommas(value: string | number | null) {
  const number = value === null ? '' : value.toString().replace(/\D/g, '');
  return number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export default formatNumberWithCommas;
